/* 
Copyright (c) Karsten Jeske and John Firth
This source code is licensed under the proprietary license found in the
LICENSE file in the root directory of this source tree.
*/

import CashFlow from "features/userParameters/CashFlow"
import { CurrentUserParameters } from "features/userParameters/UserParametersSchemata"
import type { ReactElement } from "react"
import { useFieldArray, useFormContext } from "react-hook-form"
import { toDisplayDate } from "utils/dateUtils"

// AIDEV-NOTE: Annotate mapped field inputs as readonly to satisfy strict linting without changing field-array behavior.
const AllCashFlows = () => {
  const { control, register, getValues } = useFormContext<CurrentUserParameters>()

  const { fields, append, remove } = useFieldArray({
    control,
    name: "cashFlows",
  })

  const retirementStartYearMonth = getValues("retirementStart")
  const retirementDate = toDisplayDate(retirementStartYearMonth) ?? new Date()
  const cashFlowRows: ReactElement[] = []
  for (const [index, field] of fields.entries()) {
    cashFlowRows.push(<CashFlow key={field.id} index={index} register={register} remove={remove} />)
  }

  return (
    <div className="cash-flows-tab-content">
      <div id="cash-flow-container">{cashFlowRows}</div>
      <div className="add-cash-flow-container">
        <button
          type="button"
          id="add-cash-flow-button"
          className="btn btn-secondary mt-3"
          onClick={() => {
            append({
              name: "",
              amount: 0,
              frequency: "monthly",
              inflationAdjusted: false,
              start: { year: retirementDate.getFullYear(), month: retirementDate.getMonth() + 1 },
              end: { year: retirementDate.getFullYear() + 1, month: retirementDate.getMonth() + 1 },
            })
          }}
        >
          Add Cash Flow
        </button>
      </div>
    </div>
  )
}

export default AllCashFlows
